import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Label, SingleDataSet } from 'ng2-charts';
import { ProdutoUso } from 'src/app/models/produto-uso';

@Component({
  selector: 'app-estatisticas',
  templateUrl: './estatisticas.component.html',
  styleUrls: ['./estatisticas.component.css']
})
export class EstatisticasComponent implements OnInit {

  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartColors: any[] = [];
  public pieChartBackgroundColors: any[] = [];

  public pieChartType: ChartType = 'pie';
  public pieChartLegend = false;
  public pieChartPlugins = [];

  public produtosUso: ProdutoUso[] = [];

  public currentDateLabel: string;

  constructor() { }

  ngOnInit() {
    // recuperar da api o objeto
    // exemplos

    this.produtosUso.push(new ProdutoUso('#FF0000', 'Vale Refeição', 2500, 25));
    this.produtosUso.push(new ProdutoUso('#00FF00', 'Vale Alimentação', 3000, 30));
    this.produtosUso.push(new ProdutoUso('#0000FF', 'Vale Combustível', 2500, 25));
    this.produtosUso.push(new ProdutoUso('#F000F0', 'Vale Dentista', 2000, 20));

    this.produtosUso.forEach(obj => {
      this.pieChartLabels.push(obj.produtoDescricao);
      this.pieChartData.push(obj.porcentagemGasto);
      this.pieChartBackgroundColors.push(obj.corHex);
    });

    this.pieChartColors.push({ backgroundColor: this.pieChartBackgroundColors });

    this.currentDateLabel = 'Fevereiro de 2020'
  }

}
